// extracted by mini-css-extract-plugin
export var marginNegative = "_67-5 _67-3 _67-1";
export var marginPositive = "_67-4 _67-3 _67-1";
export var modalContent = "_67-6";
export var samplesTable = "_67-8";
export var samplesTableContainer = "_67-7";
export var statBox = "_67-a";
export var tableCell = "_67-1";
export var tableCellCenter = "_67-2 _67-1";
export var tableCellRight = "_67-3 _67-1";
export var tableHeader = "_67-0";
export var trackingNumber = "_67-9";